import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api/qr-generator';

const qrGeneratorApi = axios.create({
  baseURL: API_BASE_URL,
  timeout: 300000, // 5 minutes timeout for large batches
  headers: {
    'Content-Type': 'application/json',
  },
});

// Helper function to download file from blob
const downloadFileFromBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

// Generate all QR codes
export const generateAllQRCodes = async (locationId, rooms, environment = 'production') => {
  try {
    const response = await qrGeneratorApi.post('/generate-all-qr-codes', {
      locationId,
      rooms,
      environment
    }, {
      responseType: 'blob' // Important for file downloads
    });

    // Extract filename from headers or generate one
    const contentDisposition = response.headers['content-disposition'];
    let filename = `QR_Codes_${locationId}_${new Date().toISOString().split('T')[0]}.zip`;
    
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="(.+)"/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      }
    }

    downloadFileFromBlob(response.data, filename);
    return { success: true, filename };
  } catch (error) {
    console.error('Error generating all QR codes:', error);
    throw error;
  }
};

// Generate QR codes for specific room
export const generateRoomQRCodes = async (locationId, room, environment = 'production') => {
  try {
    const response = await qrGeneratorApi.post('/generate-room-qr-codes', {
      locationId,
      room,
      environment
    }, {
      responseType: 'blob'
    });

    // Extract filename from headers or generate one
    const contentDisposition = response.headers['content-disposition'];
    let filename = `QR_Codes_${room.name}_${new Date().toISOString().split('T')[0]}.zip`;
    
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="(.+)"/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      }
    }

    downloadFileFromBlob(response.data, filename);
    return { success: true, filename };
  } catch (error) {
    console.error('Error generating room QR codes:', error);
    throw error;
  }
};

// Generate single QR code
export const generateSingleQRCode = async (url, fileName = 'qrcode.png') => {
  try {
    const response = await qrGeneratorApi.post('/generate-single-qr', {
      url,
      fileName
    }, {
      responseType: 'blob'
    });

    // Extract filename from headers
    const contentDisposition = response.headers['content-disposition'];
    let filename = fileName;
    
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="(.+)"/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      }
    }

    downloadFileFromBlob(response.data, filename);
    return { success: true, filename };
  } catch (error) {
    console.error('Error generating single QR code:', error);
    throw error;
  }
};

// Health check
export const checkHealth = async () => {
  try {
    const response = await qrGeneratorApi.get('/health');
    return response.data;
  } catch (error) {
    console.error('Health check failed:', error);
    throw error;
  }
};

export default qrGeneratorApi;